var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { HttpClient } from '@angular/common/http';
import { GetCallHistoryAction } from './call-history.actions';
import { Store } from '@ngrx/store';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "@ngrx/store";
var CallHistoryService = /** @class */ (function () {
    function CallHistoryService(http, store) {
        this.http = http;
        this.store = store;
    }
    CallHistoryService.prototype.getCallHistory = function (payload) {
        return this.http.post('/calls/history/paginated', __assign({}, payload, { pager: payload.pager
                ? __assign({}, payload.pager, { page: payload.pager.pageIndex + 1, limit: payload.pager.pageSize }) : {} }));
    };
    CallHistoryService.prototype.addFilter = function (type, value, pager) {
        var _a;
        this.store.dispatch(new GetCallHistoryAction((_a = {}, _a[type] = value, _a.pager = pager, _a)));
    };
    CallHistoryService.prototype.getPagerIndexReset = function (pager) {
        return pager ? __assign({}, pager, { pageIndex: 0 }) : null;
    };
    CallHistoryService.prototype.setCheckboxAll = function (itemsList, requestedProjectList) {
        if (!requestedProjectList.length) {
            return {
                allSelected: false,
                indeterminate: false
            };
        }
        else if (requestedProjectList.length === itemsList.length) {
            return {
                allSelected: true,
                indeterminate: false
            };
        }
        else if (!!requestedProjectList.length && !itemsList.length) {
            return {
                allSelected: false,
                indeterminate: false
            };
        }
        else {
            return {
                allSelected: true,
                indeterminate: true
            };
        }
    };
    // required for users form control, but backend expects null
    CallHistoryService.UNASSIGNED_USER_ID = -1;
    CallHistoryService.ngInjectableDef = i0.defineInjectable({ factory: function CallHistoryService_Factory() { return new CallHistoryService(i0.inject(i1.HttpClient), i0.inject(i2.Store)); }, token: CallHistoryService, providedIn: "root" });
    return CallHistoryService;
}());
export { CallHistoryService };
